// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__6nvHQ","shown":"Reveal_shown__5oDVN"};